<template>
  <component :is="tag">
    <slot/>
  </component>
</template>

<script>
import tag from '@/js/util/props/tag'

export default {
  inject: ['header'],
  props: {
    ...tag,
  },
  data() {
    return {
      oldScrollY: undefined,
      oldScrollYVector: 0,
      scrollProgress: 0,
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll() {
      const scrollY = Math.max(0, window.pageYOffset)
      const scrollYVector = scrollY - this.oldScrollY

      if (Math.sign(scrollYVector) === Math.sign(this.oldScrollYVector)) {
        this.scrollProgress += Math.abs(scrollYVector)
      } else {
        this.scrollProgress = Math.abs(scrollYVector)
      }

      this.oldScrollY = scrollY
      this.oldScrollYVector = scrollYVector

      if (!scrollY) {
        return
      }

      if (this.scrollProgress > 200) {
        this.header.$emit('hide:element', scrollYVector > 0)
      }

      // Shows nav if at top of page
      setInterval(() => {
        if (Math.max(0, window.pageYOffset) === 0) {
          this.header.$emit('hide:element', false)
        }
      }, 500)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/HeaderContainerNav.vue